import * as $gzFields from './fields.service';

export default angular.module('gazelle.components.fields', [
  'pascalprecht.translate',
  'angularMoment',
  'ngSanitize',
])
  .service($gzFields.name, $gzFields.default)
  .name;

